import React from 'react';
import LegalLayout from './LegalLayout';

const SECTIONS = [
  {
    title: '1. O que sao cookies',
    content: 'Cookies sao pequenos arquivos de texto armazenados no seu navegador quando voce visita um site. Eles permitem que o site reconheca seu dispositivo em visitas futuras e melhore sua experiencia.'
  },
  {
    title: '2. Cookies que utilizamos',
    content: 'Utilizamos cookies essenciais, necessarios ao funcionamento do site e que nao podem ser desativados, e, mediante seu consentimento, cookies que nos ajudam a entender como o site e utilizado para melhora-lo. Voce decide no banner de cookies exibido na primeira visita.'
  },
  {
    title: '3. Cookies de terceiros',
    content: 'Este site e um site institucional e comercial. Nao utilizamos pixels de redes sociais nem cookies de publicidade de terceiros. Caso ferramentas de analise sejam adotadas no futuro, elas so serao ativadas apos o seu consentimento.'
  },
  {
    title: '4. Como gerenciar seus cookies',
    content: 'Voce pode aceitar ou recusar cookies nao essenciais a qualquer momento. Tambem e possivel limpar os cookies existentes nas configuracoes do seu navegador (Chrome, Firefox, Safari e Edge oferecem essa opcao na secao de privacidade).'
  },
  {
    title: '5. Retencao',
    content: 'A sua preferencia de consentimento fica armazenada localmente no seu navegador. Cookies essenciais de sessao expiram ao fechar o navegador.'
  },
  {
    title: '6. Contato',
    content: 'Para duvidas sobre a politica de cookies, utilize o e-mail de contato indicado abaixo.'
  }
];

export default function Cookies() {
  return (
    <LegalLayout
      title="Politica de Cookies"
      canonical="https://www.libbenincorp.com/cookies"
      metaDescription="Politica de Cookies do LibbenIncorp."
      updatedAt="15 de outubro de 2026"
      sections={SECTIONS}
    />
  );
}
